"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var _ref = process.env.NODE_ENV === "production" ? {
  name: "1xkx5cp-Background",
  styles: "filter:drop-shadow(2px 9px 4px rgba(0, 0, 0, 0.1));;label:Background;"
} : {
  name: "1xkx5cp-Background",
  styles: "filter:drop-shadow(2px 9px 4px rgba(0, 0, 0, 0.1));;label:Background;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var Background = function Background(props) {
  var _useTheme = (0, _useTheme2["default"])(),
      colors = _useTheme.colors;

  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    css: _ref,
    height: 75,
    width: 375,
    viewBox: "0 0 375 75",
    preserveAspectRatio: "none"
  }, props), (0, _core.jsx)("filter", {
    id: "MobileHeader__Background",
    height: "110%",
    width: "101.9%",
    x: "-.9%",
    y: "-3.6%"
  }, (0, _core.jsx)("feOffset", {
    dy: 1,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), (0, _core.jsx)("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), (0, _core.jsx)("feColorMatrix", {
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0.0823529412 0 0 0 0 0.160784314 0 0 0 0.2 0"
  }), (0, _core.jsx)("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), (0, _core.jsx)("feGaussianBlur", {
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 0.5
  }), (0, _core.jsx)("feColorMatrix", {
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0 0 0 0 0 0.0823529412 0 0 0 0 0.160784314 0 0 0 0.1 0"
  }), (0, _core.jsx)("feMerge", null, (0, _core.jsx)("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), (0, _core.jsx)("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }))), (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M0 0h375v64.5c-44.667 3.667-93.667 5.5-147 5.5-94.667 0-170.667-6-228-18z"
  }), (0, _core.jsx)("path", {
    d: "M0 0h375v64.5c-44.667 3.667-93.667 5.5-147 5.5-94.667 0-170.667-6-228-18z",
    fill: colors.secondary
  }), (0, _core.jsx)("path", {
    d: "M0 0h375v53c-66.333 11.333-128.833 17-187.5 17S66.333 64.333 0 53z",
    fill: colors.black,
    filter: "url(#MobileHeader__Background)"
  }), (0, _core.jsx)("path", {
    d: "M0 0h375v53c-66.333 11.333-128.833 17-187.5 17S66.333 64.333 0 53z",
    fill: colors.white
  })));
};

__signature__(Background, "useTheme{{ colors }}", function () {
  return [_useTheme2["default"]];
});

var _default = Background;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Background, "Background", "/builds/bA1zbJom/0/gojob/ui-bits/src/MobileHeader/Background.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/MobileHeader/Background.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();